import { request } from './httpClient';

export function getFiles(recordId, params) {
  return request({ method: 'GET', url: `/v1/files/${encodeURIComponent(recordId)}`, params });
}

export function getFile(contentVersionId) {
  return request({ method: 'GET', url: `/v1/file/${encodeURIComponent(contentVersionId)}` });
}

export function downloadFile(contentVersionId) {
  return request({ method: 'GET', url: `/v1/download/${encodeURIComponent(contentVersionId)}` });
}

/**
 * Upload is a 2-step process per discovery:
 * - Step 1: upload ContentVersion (handled server-side in most implementations)
 * - Step 2: link uploaded ContentVersion to record via POST /v1/file/{recordId}
 *
 * This client function calls the server’s endpoint directly with whatever body
 * the server expects (typically includes ContentVersion Id and metadata fields).
 */
export function uploadFile(recordId, body) {
  return request({ method: 'POST', url: `/v1/file/${encodeURIComponent(recordId)}`, data: body });
}

